var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app",class:[
    _vm.isEdge15orDown ? 'app--isEdge15orDown' : '',
    { 'app--navigation-dark': _vm.globalDarkTheme },
    { 'app--mobile-navigation-open': _vm.showMobileNav && ['sm', 'md'].includes(_vm.$mq) },
  ]},[_c('GlobalHeader'),_vm._v(" "),_c('main',{staticClass:"app__view",class:{ 'app__view--visible': _vm.appHydrated },attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"c_navigation_mobile__mask c_box--mask",class:_vm.showMobileNav && ['sm', 'md'].includes(_vm.$mq) ? 'c_navigation_mobile__mask--active' : ''}),_vm._v(" "),_c('nuxt')],1),_vm._v(" "),_c('GlobalFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }